import type { ComponentProps } from "react"

export default function EnergyRatingB(
  props: ComponentProps<"svg"> & { fill?: string },
) {
  const { fill = "currentColor", ...svgProps } = props

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...svgProps}
    >
      <path
        d="M23.3456 9.36055L23.3455 9.36043L13.3446 0.509095C12.9773 0.181611 12.4973 -2.25237e-05 11.9992 2.09495e-09C11.5011 2.25279e-05 11.0211 0.1817 10.6538 0.509216L0.654541 9.36043C0.448577 9.54309 0.283993 9.76554 0.171293 10.0136C0.0585935 10.2616 0.000254481 10.5298 0 10.8011V22.0529C0.000606423 22.5691 0.211515 23.064 0.586456 23.4291C0.961398 23.7941 1.46975 23.9994 2 24H22C22.5302 23.9994 23.0386 23.7941 23.4135 23.4291C23.7885 23.064 23.9994 22.5691 24 22.0529V10.8011C23.9997 10.5299 23.9414 10.2617 23.8287 10.0137C23.7161 9.76566 23.5515 9.54321 23.3456 9.36055Z"
        fill={fill}
      />
      <path
        className="rating"
        d="M7.88992 20V8.36365H12.3445C13.1854 8.36365 13.8842 8.49622 14.4411 8.76137C15.0017 9.02274 15.4202 9.38069 15.6967 9.83524C15.977 10.2898 16.1172 10.8049 16.1172 11.3807C16.1172 11.8542 16.0263 12.2595 15.8445 12.5966C15.6627 12.9299 15.4183 13.2008 15.1115 13.4091C14.8047 13.6174 14.4619 13.7671 14.0831 13.858V13.9716C14.496 13.9943 14.8918 14.1212 15.2706 14.3523C15.6532 14.5796 15.9657 14.9015 16.2081 15.3182C16.4505 15.7349 16.5717 16.2386 16.5717 16.8296C16.5717 17.4318 16.4259 17.9735 16.1342 18.4546C15.8426 18.9318 15.4032 19.3087 14.8161 19.5852C14.2289 19.8618 13.4903 20 12.6002 20H7.88992ZM9.99788 18.2386H12.2649C13.0301 18.2386 13.5812 18.0928 13.9183 17.8011C14.2592 17.5057 14.4297 17.1269 14.4297 16.6648C14.4297 16.3201 14.3445 16.0095 14.174 15.733C14.0036 15.4527 13.7611 15.233 13.4467 15.0739C13.1323 14.911 12.7573 14.8296 12.3217 14.8296H9.99788V18.2386ZM9.99788 13.3125H12.0831C12.4467 13.3125 12.7744 13.2462 13.0661 13.1136C13.3577 12.9773 13.5869 12.786 13.7536 12.5398C13.924 12.2898 14.0092 11.9943 14.0092 11.6534C14.0092 11.2027 13.8502 10.8315 13.532 10.5398C13.2176 10.2481 12.7498 10.1023 12.1286 10.1023H9.99788V13.3125Z"
        fill="white"
      />
    </svg>
  )
}
